import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

const STORAGE_KEY = "sm-cookie-consent-v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        // Defer a tick so the entrance animation runs after first paint
        const t = setTimeout(() => setVisible(true), 600);
        return () => clearTimeout(t);
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ accepted: true, ts: new Date().toISOString() })
      );
    } catch (e) {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="sm-cookie" role="dialog" aria-live="polite" data-testid="cookie-banner">
      <div className="sm-cookie__inner">
        <div className="sm-cookie__text">
          <div className="sm-cookie__title">We use only essential cookies</div>
          <p>
            This site uses strictly necessary cookies required for it to function. We do not use
            advertising or third-party analytics cookies. See our{" "}
            <Link to="/privacy" className="sm-cookie__link" data-testid="cookie-privacy-link">
              Privacy Policy
            </Link>
            .
          </p>
        </div>
        <div className="sm-cookie__actions">
          <button
            type="button"
            className="sm-btn sm-btn--gold sm-cookie__accept"
            onClick={accept}
            data-testid="cookie-accept"
          >
            Accept &amp; close
          </button>
          <button
            type="button"
            className="sm-cookie__close"
            onClick={accept}
            aria-label="Close cookie notice"
            data-testid="cookie-close"
          >
            <X size={18} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </div>
  );
}
